import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ContestList from 'components/Contest/layouts/ContestList';
import { selectCounts } from 'mt-react-common/modules/main/reducers/static/states/counts/reducer';

const MyParticipation = props => (
  <React.Fragment>
    <h1 className="page-header hidden-xs">
      <i className="fa fa-trophy fa-lg" />
      &nbsp;Конкурсы – <strong>Участвую</strong>{' '}
      <span className="badge badge-primary badge-circle text-super">
        {props.counts.me_contests.count}
      </span>
    </h1>
    <ContestList staticQueryParams={{ search_type: 'me' }} />
  </React.Fragment>
);

MyParticipation.propTypes = {
  // CONNECT STATES
  counts: PropTypes.shape({
    me_contests: PropTypes.shape({
      count: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  counts: selectCounts(state)
});

export default connect(mapStateToProps)(MyParticipation);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/MyParticipation/MyParticipation.js